import type { MicrosoftAdsContext } from '@/shared/lib/microsoftAdsContext';

import { BASE_URL } from './constants';
import { put } from './requestMethods';
import { sendAdsActivity } from './sendAdsActivity';

const URL = `${BASE_URL}/api/user/microsoft-ads`;

type MicrosoftAdsActivity = {
  context: MicrosoftAdsContext;
  event_id: string;
  event_name: 'begin_checkout' | 'preview_view';
  price_id?: string;
  quantity?: number;
};

export const MICROSOFT_ADS_API = {
  sendActivity: (data: MicrosoftAdsActivity) => sendAdsActivity(`${URL}/activity`, data),
  saveContext: (data: MicrosoftAdsContext, signal?: AbortSignal) => put<void>(URL, { data, signal }),
};
